import React from "react";
import { ContentWrapperCard } from "./organisms/ContentWrappingCard";
import { Placeholder } from "react-bootstrap";

export const LoadingCarrito = () => {
  return (
    <ContentWrapperCard>
      {Array.from(Array(20).keys()).map((k) => (
        <Placeholder key={k} className="w-100" bg="light" size="lg" />
      ))}
    </ContentWrapperCard>
  );
};
